
import Vue from 'vue'
import { toString } from 'lodash'

interface Data {
  roomID: string | null
}

export default Vue.extend({
  data: (): Data => ({
    roomID: null
  }),

  watch: {
    $route() {
      this.setup()
    }
  },

  created() {
    this.setup()
  },

  methods: {
    setup() {
      this.roomID = toString(this.$route.query.room)

      if (this.roomID.length === 0) {
        this.roomID = null
      }
    }
  }
})
